<script setup>
import { toUnderscore, useTextStore } from '@/stores/texts';
import { onMounted } from 'vue';
import { ref } from 'vue';


const props = defineProps({
  industry: {
    type: Number,
    required: true
  },
  region: {
    type: Number,
    required: true
  },
})

const textStore = useTextStore()

const title = ref('')
const button = ref('')
const content = ref('')
const link = ref('')

const id = ref(null)

async function getBanner() {
  const lang = toUnderscore(textStore.language)
  const response = await fetch(
    `${import.meta.env.VITE_API_HOST}/banner/?industry=${props.industry}&region=${props.region}&language=${lang}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }
  );
  if (response.ok) {
    const data = await response.json()
    content.value = data.content
    button.value = data.button_text
    title.value = data.title
    link.value = data.target
    id.value = data.uuid
  }
}

onMounted(() => {
  getBanner()
})

</script>

<template>
  <div class="card no-print" v-if="content">
    <header>
      <h3>
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.68359 19.3711V17.3711H6.68359V10.3711C6.68359 8.98776 7.10026 7.76276 7.93359 6.69609C8.76693 5.61276 9.85026 4.90443 11.1836 4.57109V3.87109C11.1836 3.45443 11.3253 3.10443 11.6086 2.82109C11.9086 2.52109 12.2669 2.37109 12.6836 2.37109C13.1003 2.37109 13.4503 2.52109 13.7336 2.82109C14.0336 3.10443 14.1836 3.45443 14.1836 3.87109V4.57109C15.5169 4.90443 16.6003 5.61276 17.4336 6.69609C18.2669 7.76276 18.6836 8.98776 18.6836 10.3711V17.3711H20.6836V19.3711H4.68359ZM12.6836 22.3711C12.1336 22.3711 11.6586 22.1794 11.2586 21.7961C10.8753 21.3961 10.6836 20.9211 10.6836 20.3711H14.6836C14.6836 20.9211 14.4836 21.3961 14.0836 21.7961C13.7003 22.1794 13.2336 22.3711 12.6836 22.3711ZM8.68359 17.3711H16.6836V10.3711C16.6836 9.27109 16.2919 8.32943 15.5086 7.54609C14.7253 6.76276 13.7836 6.37109 12.6836 6.37109C11.5836 6.37109 10.6419 6.76276 9.85859 7.54609C9.07526 8.32943 8.68359 9.27109 8.68359 10.3711V17.3711Z"
            fill="#34333c" />
        </svg>
        <span>
          {{ title }}
        </span>
      </h3>
    </header>
    <section>
      <p v-html="content"></p>
    </section>
    <a class="btn" :href="link" target="_blank" rel="noopener noreferrer">
      <span>
        {{ button }}
      </span>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="12.1664" y1="7.44081" x2="0.898326" y2="18.7089" stroke="#34333c" stroke-width="2.54776" />
        <path d="M0.117188 6.49463L13.1069 6.49446L13.1069 19.4843" stroke="#34333c" stroke-width="2.54776" />
      </svg>
    </a>
  </div>
</template>

<style scoped>
header svg {
  border-radius: 100%;
  border: solid 1px #34333c;
  padding: 5px;
}

header h3 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: var(--font-size);
  margin: 0;
  transition: all 200ms;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card {
  margin: 1.5rem 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 1.5rem;
  background-color: #bd9999;
}


.card section p {
  margin: 0;
}

.btn {
  border-radius: 67px;
  background-color: #34333c;
  color: white;
  text-decoration: none;
  font-weight: bold;
  padding: 9px 9px;
  display: flex;

  align-self: center;
  align-items: center;
  justify-content: space-between;
  transition: all 200ms;
}

.btn:hover {
  transform: scale(0.9);
}

.btn span {
  padding: 0px 40px 0 20px;
  font-size: var(--font-size);
  text-align: center;
}

.btn svg {
  background-color: #F9F1F1;
  border-radius: 100%;
  padding: 9px 9px 15px 15px;
}


.card section {
  padding: 20px 15px;
  margin-bottom: 1rem;
}

header {
  padding: 20px 15px;
  gap: 10px;
  background: transparent;
  display: flex;
  flex-direction: row;
}

@media screen and (min-width: 768px) {
  header {
    padding: 20px 40px;
  }

  .card section {
    padding: 20px 40px;
  }
}
</style>
